import React, { useLayoutEffect, useState } from 'react';
import AdvancedWordProcessor from '../../components/editors/AdvancedWordProcessor';
import CustomSpreadsheet from '../../components/editors/CustomSpreadsheet';
import HandwritingNotebook from '../../components/editors/HandwritingNotebook';

const lockedCells = [];
// Keep each visited view in its own iframe. Reusing one iframe for two documents,
// or changing its key on tab switches, discards scroll, selection and undo state.
export default function StudentLectureNotes({ viewMode, activeTab, wordContent, excelData, handNotes, liveWordContent, liveExcelData, liveHandNotes, onWordChange, onExcelChange, onHandNotesChange }) {
    const selected = `${viewMode}:${activeTab}`;
    const [visited, setVisited] = useState(() => [selected]);
    useLayoutEffect(() => { setVisited(previous => previous.includes(selected) ? previous : [...previous, selected]); }, [selected]);
    return <>{visited.map(id => {
        const [view, tab] = id.split(':');
        const live = view === 'live';
        const visible = id === selected;
        return <section key={id} aria-label={`${live ? 'Faculty live' : 'Private'} ${tab === 'word' ? 'word notes' : tab === 'hand' ? 'hand notes' : 'spreadsheet'}`} aria-hidden={!visible} inert={!visible}
            className="absolute inset-0 flex flex-col" style={{ visibility: visible ? 'visible' : 'hidden', pointerEvents: visible ? 'auto' : 'none' }}>
            {/* Visibility keeps the iframe's dimensions intact, unlike display:none. */}
            {tab === 'word' ? <AdvancedWordProcessor value={live ? liveWordContent : wordContent} onChange={live ? undefined : onWordChange} readOnly={live} preserveViewport={live}/>
                : tab === 'hand' ? <HandwritingNotebook data={live ? liveHandNotes : handNotes} onChange={live ? undefined : onHandNotesChange} readOnly={live} preserveViewport={live}/>
                : <CustomSpreadsheet data={live ? liveExcelData : excelData} onChange={live ? undefined : onExcelChange} editableCells={live ? lockedCells : undefined} preserveViewport={live}/>}
        </section>;
    })}</>;
}
